import { cn } from '~/utils/cn';

import { Text } from '../../atoms/Text/view';

export interface TabItem<T extends string = string> {
  key: T;
  label: string;
}

interface PropsTabs<T extends string> {
  items: TabItem<T>[];
  active: T;
  onChange: (key: T) => void;
  className?: string;
}

export default function Tabs<T extends string>({
  items,
  active,
  onChange,
  className,
}: PropsTabs<T>) {
  return (
    <div className={cn('flex items-center gap-quark rounded-full bg-intense-03 p-[3px]', className)}>
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={() => onChange(item.key)}
          className={cn(
            'flex-1 h-[36px] rounded-full transition-colors',
            active === item.key ? 'bg-intense-01 shadow-level1' : 'bg-transparent',
          )}
        >
          <Text
            className={cn(
              'text-captionLG',
              active === item.key ? 'color-primary-01' : 'color-intense-06',
            )}
          >
            {item.label}
          </Text>
        </button>
      ))}
    </div>
  );
}
